/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import request from '@hb/sharp-request';
import { newGatewayUrl } from '@/constant';
import platform from '@/shared/utils/platform';
import { userActionCallBackParamsTypes } from './types';


// 用户运营事件采集
export const userActionCallBack = (
  params: userActionCallBackParamsTypes,
): Promise<void> => request.postGate(
  'f.user.action.callback', // f.user.action.callback(用户运营事件采集)  https://yapi.hellobike.cn/project/3415/interface/api/234045
  {
    ...params,
    ...platform.currentPlatformType,
  },
  {
    baseURL: newGatewayUrl, // soa接口
    showLoading: undefined,
  },
);

const CallBackAPI = {
  userActionCallBack,
};

export default CallBackAPI;
